var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Asset" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("get.asset.general"),
                    active: !_vm.developmentMode
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ProducerId",
                            error: _vm.$v.form.ProducerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "ASSET_PRODUCER",
                              disabled: _vm.insertReadonly.ProducerId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("ProducerId", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BrandId",
                            error: _vm.$v.form.BrandId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "ASSET_BRAND",
                              disabled: _vm.insertReadonly.BrandId
                            },
                            on: {
                              input: function($event) {
                                return _vm.getModels($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ModelId",
                            error: _vm.$v.form.ModelId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.models,
                              label: "Label",
                              disabled:
                                _vm.insertReadonly.ModelId || !_vm.form.BrandId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("ModelId", $event)
                              }
                            },
                            model: {
                              value: _vm.model,
                              callback: function($$v) {
                                _vm.model = $$v
                              },
                              expression: "model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AssetTypeId",
                            error: _vm.$v.form.AssetTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "ASSET_TYPE",
                              disabled: _vm.insertReadonly.AssetTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("AssetTypeId", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TypeId",
                            error: _vm.$v.form.TypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextAsset/api/AssetType/Search",
                              disabled: _vm.insertReadonly.TypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectAssetType($event)
                              }
                            },
                            model: {
                              value: _vm.type,
                              callback: function($$v) {
                                _vm.type = $$v
                              },
                              expression: "type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AssetClassId",
                            error: _vm.$v.form.AssetClassId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextAsset/api/AssetClass/Search",
                              disabled: _vm.insertReadonly.AssetClassId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "AssetClassId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.assetClass,
                              callback: function($$v) {
                                _vm.assetClass = $$v
                              },
                              expression: "assetClass"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TrackTypeId",
                            error: _vm.$v.form.TrackTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextAsset/api/AssetTrackType/Search",
                              disabled: _vm.insertReadonly.TrackTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "TrackTypeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Barcode",
                            error: _vm.$v.form.Barcode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Barcode
                            },
                            model: {
                              value: _vm.form.Barcode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Barcode", $$v)
                              },
                              expression: "form.Barcode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: "Mobilya Masrafı",
                            error: _vm.$v.form.FurnitureExpense
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.FurnitureExpense
                            },
                            model: {
                              value: _vm.form.FurnitureExpense,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "FurnitureExpense", $$v)
                              },
                              expression: "form.FurnitureExpense"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: "Önyüz Sayısı",
                            error: _vm.$v.form.ShelfQuantity
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.ShelfQuantity
                            },
                            model: {
                              value: _vm.form.ShelfQuantity,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ShelfQuantity", $$v)
                              },
                              expression: "form.ShelfQuantity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.assetPropertyValues && _vm.assetPropertyValues.length > 0
                ? _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("get.asset.properties") } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-table", {
                                attrs: {
                                  responsive: "",
                                  autoWidth: "",
                                  bordered: "",
                                  small: "",
                                  items: _vm.assetPropertyValues,
                                  fields: _vm.assetPropertyValueFields
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "head()",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t(data.label)) +
                                              "\n              "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(Description1)",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                item.Property
                                                  ? item.Property.Label
                                                  : item.Description1
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(Value)",
                                      fn: function(data) {
                                        return [
                                          _c("NextInput", {
                                            attrs: { type: "text" },
                                            model: {
                                              value: data.item.Value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  data.item,
                                                  "Value",
                                                  $$v
                                                )
                                              },
                                              expression: "data.item.Value"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  885349764
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0970215c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0970215c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Asset/insert.vue
// module id = null
// module chunks = 